import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="join">
      <h1>
        <span className="mono">?</span> Not here
      </h1>
      <p>
        Nothing at this address. <Link to="/clips">The clips</Link> are this way.
      </p>
    </div>
  );
}
